'use strict'

import wpapi from './wpapi'
import listingsResults from './listings.results'

let self

export default self = {
  container : document.querySelector('main.building-single #listings'),

  init : () => {
    self.buildingAddr = self.getBuildingAddress()
    self.articleContainer = self.container.querySelector('.listings-results .listings')

    //if ( !self.buildingAddr ) return self.noListings()

    self.getPublicListingsFromAddress()
      .then( listings => {
        //if ( listings.length === 0 ) return self.noListings()

        return self.createArticlesFromListings(listings)
      })
      .then( res => console.log('Listings populated', res) )
  },

  getBuildingAddress : () => {
    const listingTitle = document.querySelector('.listing-title')
    const addressContainer = listingTitle.querySelector('span')

    if ( !addressContainer ) return null

    return addressContainer.innerHTML
  },

  getPublicListingsFromAddress : () => {
    wpapi.init()

    return wpapi.wp.publicListings()
      .perPage(100)
      .param( 'meta_key', 'address' )
      .param( 'meta_value', self.buildingAddr )
  },

  createArticlesFromListings : listings => new Promise( (resolve, reject) => {
    let articleArr = []

    for (let listing of listings) {
      const article = listingsResults.getListingArticleHTML({ listing : listing, lazyLoad : false, hideForPagination : false })
      console.log(article);
      listing.el = article
      self.articleContainer.appendChild(article)
    }

    resolve(true)
  }),

  noListings : () => {
    self.container.classList.add('hidden')
    document.querySelector('nav.detail-nav a[href="#listings"]').classList.add('hide')
  }
}
